import { Component, OnInit } from '@angular/core';

import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { AccountFormModelService } from '../services/account-form-model.service';
import { AccountPageService } from '../services/account-page.service';
import { _CentralPageService } from '../../shared/central-page/services/_central-page.service';
import { FooterService } from '../../shared/footer/footer.service';
import { IFooterData } from '../../shared/footer/models/footer-data';
import { IHeaderData } from '../../shared/header/models/header-data';
import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { RecoverDetailsComponent } from './components/recover-details/recover-details.component';
import { SinglePageComponent } from '../../shared/central-page/container/single-page/single-page.component';
import { _SinglePageRouteComponent } from 'src/app/infrastructure/components/route-components/_single-page-route-component';
import { SinglePageService } from '../../shared/central-page/services/single-page.service';
import { pageTransitionAnimation } from 'src/app/infrastructure/animations/route-animations';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { pageLayout, TPageLayout } from 'src/app/infrastructure/models/page-layout';
import { ApplicationUserService } from 'src/app/infrastructure/services/application-user.services/application-user.service';
import { ActivatedRouteService } from 'src/app/infrastructure/services/route-service/activated-route.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { ROUTE_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';

@Component({
    selector: 'app-recover',
    templateUrl: './recover.component.html',
    styleUrls: ['./recover.component.scss'],
    standalone: true,
    imports: [
        RecoverDetailsComponent,
        SinglePageComponent,
    ],
    providers: [
        {provide: ROUTE_PAGE, useValue: routePage.recover},
        ApplicationUserService,
        ActivatedRouteService,
        AccountFormModelService,
        AccountPageService,
        FooterService,
        SinglePageService,
        {provide: _FormModelService, useExisting: AccountFormModelService},
        {provide: _CentralPageService, useExisting: SinglePageService},
        {provide: _PageService, useExisting: AccountPageService},
    ],
    animations: [
        pageTransitionAnimation
    ],
})
export class RecoverComponent
    extends _SinglePageRouteComponent<null, null>
    implements OnInit
{
    // Services
    override readonly userClaimService = this._applicationUserService;
    override readonly activatedRouteService = this._activatedRouteService;
    override readonly centralPageService = this._centralPageService;
    override readonly footerService = this._footerService;
    override readonly formModelService = this._formModelService;
    override readonly loadingPageService = this._loadingPageService;
    override readonly loadingService = this._loadingService;
    override readonly pageService = this._pageService;
    override readonly reloadService = this._reloadService;

    // Data
    override headerData: Partial<IHeaderData> = {
        sideBlockLeft_hide: false,
        sideBlockRight_hide: true,
    };
    override footerData: Partial<IFooterData> = {};
    override returnPage: IPageData | null = null;
    override btnCancelData = null;
    override btnDeleteData = null;
    override btnEditData = null;
    override btnSaveData = null;
    override isStartPage = false;
    override pageCurrent_name = routePage.recover;
    override pageLayout: TPageLayout = pageLayout.detailsPage;

    // Templates
    override readonly template_details$$ = this._template_details_viewChild$$;
    override readonly template_edit$$ = this._template_edit_viewChild$$;
    override readonly template_footerLeft$$ = this._template_footerLeft_viewChild$$;

    override ngOnInit(): void {
        super._ngOnInit();
    }

    override emit_onEscape(): void {
        super._emit_onEscape();
    }

    override emit_onPageLoaded(): void {
        super._emit_onPageLoaded();
    }
}
